<script>
import PageHeader from "@/components/page-header.vue";
import Layout from "@/views/layouts/main.vue";
import storeAdd from "@/views/pages/Dilfoods/Restaurants/Stores/add.vue";
import axios from "axios";
import { StorePath, USERSPATH } from "@/path";
import Swal from "sweetalert2";
import zomatoicon from "@/assets/images/platform-icon-zomato.svg";
import swiggyicon from "@/assets/images/platform-swiggy.svg";
import thrive from "@/assets/images/thrive-platform.png";
import uengage from "@/assets/images/uengage-platform.jpeg";
import toggle_store from "@/views/pages/Dilfoods/Restaurants/Stores/toggle_store";
import items from "./items.vue";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";
export default {
  components: {
    toggle_store,
    Layout,
    PageHeader,
    "store-add": storeAdd,
    items,
    SelectWithSearch,
  },
  computed: {
    zomatoicon() {
      return zomatoicon;
    },
    swiggyicon() {
      return swiggyicon;
    },
    thrive() {
      return thrive;
    },
    USERSPATH() {
      return USERSPATH;
    },
    uengage() {
      return uengage;
    },
  },
  data() {
    return {
      title: "Locations",
      items: [
        {
          text: "List",
        },
        {
          text: "Location",
          active: true,
        },
      ],
      stores: [],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      filter: [],
      fields: [
        { key: "r_id", label: "Ref ID", class: "d-none d-md-table-cell" },
        { key: "name", label: "Name" },
        {
          key: "account_manager",
          label: "AM",
        },
        { key: "brand", label: "Brand" },
        { key: "city", label: "City" },
        { key: "assoc_platforms", label: "Platforms" },
        {
          key: "menu_active",
          label: "Menu Active",
          class: "d-none d-md-table-cell",
        },
        { key: "actions", label: "Actions", class: "d-none d-md-table-cell" },
      ],
      restaurants: [],
      selected_store: null,
      selected_menu: null,
      store_reload: 0,
      current_page: 1,
      search: "",
      trash: "",
      storeToggleData: {},
      storeToggleRevert: null,
      up_status: true,
      manager: null,
    };
  },
  mounted() {
    this.getStores();
  },
  watch: {
    current_page() {
      this.getStores();
    },
    search() {
      this.getStores();
    },
    trash() {
      this.getStores();
    },
    up_status() {
      this.getStores();
    },
    manager() {
      this.getStores();
    },
  },
  methods: {
    getAbbreviation(name) {
      return name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase();
    },
    getIcon(v) {
      if (v == "zomato") {
        return this.zomatoicon;
      } else if (v == "swiggy") {
        return this.swiggyicon;
      } else if (v == "thrive") {
        return this.thrive;
      } else if (v == "uengage") {
        return this.uengage;
      }
    },
    async showItems(v, m) {
      this.selected_store = v;
      this.selected_menu = m;
      this.$bvModal.show("bv-items-list");
    },
    async getStores() {
      try {
        let params = {
          page: this.current_page,
          search: this.search,
          manager: this.manager,
        };
        if (this.trash == true) {
          params.trash = true;
        }
        let res = await axios.get(this.base_url + StorePath.GET_STORES, {
          params: params,
        });
        if (res.data.status) {
          this.stores = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async pushToUrbanPiper(id) {
      try {
        let res = await axios.post(
          this.base_url + StorePath.PUSH_TO_UP + "/" + id
        );
        if (res.data.status) {
          Swal.fire({
            title: "Store Pushed To Urban Piper Successfully",
            showCancelButton: true,
          });
        } else {
          throw new Error(res.data.message);
        }
      } catch (e) {
        console.log(e);
        this.$store.commit("setLoader", false);
        Swal.fire({
          title: e.message,
          showCancelButton: true,
        });
      }
    },
    deleteData(store) {
      let _this = this;
      Swal.fire({
        title: "Are you sure to delete store (Also disable urban piper)?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't save`,
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let res = await axios.delete(
            this.base_url + StorePath.DELETE_STORE + "/" + store.id
          );
          if (res.data.status) {
            Swal.fire("Saved!", "", "success");
            _this.getStores();
          } else {
            Swal.fire("Failed to delete store", "", "info");
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    },
    onStoreToggleModalHide() {
      // let index = this.stores.data.findIndex(f => f.id == this.storeToggleData.store.id);
      // if(index != -1){
      //   this.stores.data[index].platform_data[this.storeToggleData.platform_data.text].is_enabled = this.storeToggleRevert ? 'enable' : 'disable';
      // }
      this.getStores();
    },
    setToggle(v) {
      this.storeToggleRevert = v;
    },
    setEdit(v) {
      this.selected_store = v;
      this.$root.$emit("bv::toggle::collapse", "add-store-sidebar");
    },
    reloadStore() {
      this.selected_store = null;
      this.getStores();
      this.$root.$emit("bv::toggle::collapse", "add-store-sidebar");
    },
    toggleStatus(v) {
      this.selected_store = v;
      this.$root.$emit("bv::toggle::collapse", "toggle-store");
    },
    openTimer(e, store, platform_data) {
      this.storeToggleData = {
        action: e,
        store: store,
        platform_data: platform_data,
      };

      this.$bvModal.show("bv-toggle-store");
    },
    async downloadStoreToggles() {
      try {
        let res = await axios.get(
          "https://pos-webhook-api.dilfoods.in/v1/order/getStoreToggleReport",
          {
            responseType: "blob", // Ensures response is treated as a binary file
          }
        );

        // Create a Blob from the response data
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a download link
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "StoreToggleReport.xlsx"); // Set the file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },
    async toggleStore(e, store, platform_data) {
      try {
        this.storeToggleRevert = !e;
        let res = await axios.post(this.base_url + StorePath.STORE_TOGGLE_UP, {
          store_id: store.id,
          platforms: platform_data.text,
          action: e ? "enable" : "disable",
        });
        if (res.data.status) {
          this.$bvToast.toast(
            platform_data.text +
              "of store " +
              store.name +
              (e ? " Enabled Successfully" : " Disabled Successfully"),
            {
              title: `Store Toggled`,
              variant: "success",
              solid: true,
            }
          );
        } else {
          this.$bvToast.toast("Failed to toggle", {
            title: `Store Toggled`,
            variant: "danger",
            solid: true,
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.$bvModal.hide("bv-toggle-store");
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12 p-1">
        <div class="card">
          <div class="card-body p-0 p-sm-2" style="margin-bottom: 50px">
            <div class="row">
              <div class="col-md-8">
                <b-button
                  v-b-toggle.add-store-sidebar
                  @click="() => (this.selected_store = null)"
                  class="btn btn-primary mb-10 pb-10"
                  >Add Location</b-button
                >
                <!--                <label class="d-inline-flex align-items-center mr-5 ml-5">-->
                <!--                  Urban Piper Status:&nbsp;-->
                <!--                  <b-form-checkbox switch v-model="up_status"></b-form-checkbox>-->
                <!--                </label>-->
              </div>
              <b-sidebar
                id="add-store-sidebar"
                title="Add Store"
                backdrop-variant="dark"
                backdrop
                shadow
                right
                width="485px"
                v-if="
                  $store.state.authfack.user.permissions.filter(
                    (f) => f.name == 'StoreEdit'
                  ).length > 0 ||
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name == 'SuperAdmin'
                  ).length > 0
                "
              >
                <store-add
                  :selected_store="selected_store"
                  @reload="reloadStore"
                  :key="store_reload"
                ></store-add>
              </b-sidebar>
              <b-modal
                id="bv-toggle-store"
                hide-footer
                @hide="onStoreToggleModalHide"
              >
                <toggle_store
                  @setToggle="setToggle"
                  :data="storeToggleData"
                ></toggle_store>
              </b-modal>
              <b-modal
                id="bv-items-list"
                size="xl"
                hide-footer
                :title="
                  selected_store?.name +
                  ' - ' +
                  selected_store?.brand.name +
                  ' - ' +
                  selected_menu?.menu
                "
              >
                <items
                  :selected_store="selected_store"
                  :menu="selected_menu"
                ></items>
              </b-modal>
              <!-- Search -->
              <div class="col-sm-12 col-md-4 mt-2 mt-sm-0">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right d-flex justify-content-between"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      class="form-control form-control-sm ml-2"
                      debounce="100"
                    ></b-form-input>
                  </label>
                  <label class="d-inline-flex align-items-center">
                    Trash:
                    <b-form-checkbox switch v-model="trash"></b-form-checkbox>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <b-row>
              <b-col sm="4">
                <label>Account Managers</label>
                <SelectWithSearch
                  :search_api="USERSPATH.GET_ACCOUNTMANAGET_USERS"
                  extra_params="&role=AccountManagers"
                  track_by="id"
                  display="name"
                  @selectedOption="(v) => (manager = v)"
                ></SelectWithSearch>
              </b-col>
              <b-col sm="4" style="align-self: flex-end; margin-bottom: 2px">
                <b-button variant="success" @click="downloadStoreToggles()">
                  Download Toggle Report
                </b-button>
              </b-col>
            </b-row>
            <div class="table-responsive mb-0">
              <template>
                <b-table
                  :items="stores.data"
                  :fields="fields"
                  responsive="md"
                  :filter="filter"
                  :current-page="current_page"
                  class="small-font-on-small-screen"
                >
                  <template v-slot:cell(r_id)="row">
                    {{ row.item.ref_id }}
                  </template>
                  <template v-slot:cell(name)="row">
                    <p style="max-width: 200px">{{ row.item.name }}</p>
                  </template>
                  <template v-slot:cell(brand)="row">
                    <p style="max-width: 200px" class="d-none d-md-block">
                      {{ row.item.brand.name }}
                    </p>
                    <p style="max-width: 200px" class="d-md-none">
                      {{ getAbbreviation(row.item.brand.name) }}
                    </p>
                  </template>
                  <template v-slot:cell(city)="row">
                    <p class="d-none d-md-block">
                      {{ row.item.restaurant.city }}
                    </p>
                    <p class="d-md-none">
                      {{ row.item.restaurant.city.substring(0, 3) }}
                    </p>
                  </template>
                  <template v-slot:cell(account_manager)="row">
                    <p class="d-none d-md-block">
                      {{
                        row.item.restaurant.am
                          ? row.item.restaurant.am.name
                          : ""
                      }}
                    </p>
                    <p class="d-md-none">
                      {{
                        row.item.restaurant.am
                          ? row.item.restaurant.am.name.substring(0, 3)
                          : ""
                      }}
                    </p>
                  </template>
                  <template v-slot:cell(assoc_platforms)="row">
                    <b-row
                      v-for="(im, imk) in row.item.platform_data"
                      :key="imk"
                    >
                      <b-col cols="4">
                        <img
                          :key="imk"
                          :src="getIcon(imk)"
                          style="width: 15px"
                        />
                      </b-col>
                      <b-col cols="4">
                        <b-checkbox
                          size="sm"
                          switch
                          @change="toggleStore($event, row.item, im)"
                          :checked="im?.is_enabled == 'enable'"
                        ></b-checkbox>
                      </b-col>
                    </b-row>
                  </template>
                  <template v-slot:cell(menu_active)="row">
                    <b-row v-for="(m, mi) in row.item.menu_active" :key="mi">
                      <b-col sm="12">
                        <a
                          href="javascript:void(0);"
                          @click="showItems(row.item, m)"
                        >
                          {{ m.menu }} -
                          {{
                            Number.isInteger(parseFloat(m.live_percentage))
                              ? parseFloat(m.live_percentage).toString()
                              : parseFloat(m.live_percentage).toFixed(2)
                          }}%
                        </a>
                      </b-col>
                    </b-row>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <b-button
                      v-if="
                        $store.state.authfack.user.permissions.filter(
                          (f) => f.name == 'StorePushToUp'
                        ).length > 0 ||
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0
                      "
                      @click="pushToUrbanPiper(row.item.id)"
                      class="mr-2"
                      variant="primary"
                      v-b-tooltip:hover
                      title="Push to urban piper"
                    >
                      <i class="fa fa-cloud-upload-alt"></i>
                    </b-button>
                    <b-button
                      v-if="
                        $store.state.authfack.user.permissions.filter(
                          (f) => f.name == 'StoreEdit'
                        ).length > 0 ||
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0
                      "
                      @click="setEdit(row.item)"
                      variant="primary"
                    >
                      <i class="fa fa-pen"></i>
                    </b-button>
                    <b-button
                      v-if="
                        (row.item.deleted_at != null &&
                          $store.state.authfack.user.permissions.filter(
                            (f) => f.name == 'StoreEdit'
                          ).length > 0) ||
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0
                      "
                      @click="deleteData(row.item)"
                      variant="success"
                      class="ml-1"
                    >
                      <i class="fa fa-trash-restore"></i>
                    </b-button>
                    <b-button
                      v-if="
                        (row.item.deleted_at == null &&
                          $store.state.authfack.user.permissions.filter(
                            (f) => f.name == 'StoreEdit'
                          ).length > 0) ||
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0
                      "
                      @click="deleteData(row.item)"
                      variant="danger"
                      class="ml-1"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </template>
                </b-table>
              </template>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="stores.key"
                      v-model="current_page"
                      :total-rows="stores.total"
                      :per-page="stores.per_page"
                      class="dataTables_paginate"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.custom-control-label::before {
  border: 1px solid #f11818;
}
.custom-switch .custom-control-label::after {
  background-color: #f11818;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #29a900;
  background-color: #29a900;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
@media (max-width: 575.98px) {
  /* Bootstrap's 'sm' breakpoint */
  .small-font-on-small-screen {
    font-size: 12px; /* Adjust to your desired small font size */
  }

  /* Adjust font size for table cells */
  .small-font-on-small-screen td,
  .small-font-on-small-screen th {
    color: black !important;
    font-size: 12px; /* Ensure table cells have the smaller font size */
  }
}
.dataTables_paginate {
  display: flex !important;
}
</style>
